export const environment = {
  production: true,
  isMockEnabled: false, // You have to switch this, when your real back-end is done
  authTokenKey: "lemaTokenKey",
  ApiURL: "https://api-staging.lema.dk/api",
  AppName: "LEMA",
  appVersion: require("../../package.json").version,
};
